"use strict";

exports.__esModule = true;
var _ErrorAlert = require("./ErrorAlert");
Object.keys(_ErrorAlert).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorAlert[key]) return;
  exports[key] = _ErrorAlert[key];
});